import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedAxios } from '../useAuthenticatedAxios';
import { toast } from '../../../components/Toast';
import { adminUserKeys } from './adminUsers.key';

export function useDeleteAdminUser() {
  const getAxios = useAuthenticatedAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId: string) => {
      const axios = await getAxios();
      await axios.delete(
        `/api/v1/admin-users/${encodeURIComponent(userId)}`
      );
    },
    onSuccess: () => {
      toast.success('Administratör borttagen');
      queryClient.invalidateQueries({ queryKey: adminUserKeys.all });
    },
    onError: () => toast.error('Kunde inte ta bort administratör'),
  });
}
